import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Link,
  styled,
  useTheme,
  alpha
} from '@mui/material';

const StyledFooter = styled('footer')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  marginTop: 'auto',
  borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  width: '100%',
  position: 'relative',
  bottom: 0,
}));

const FooterLinksContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(1),
  '& a': {
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    fontSize: '0.8125rem',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

const Divider = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 1,
  backgroundColor: alpha(theme.palette.divider, 0.1),
  margin: theme.spacing(1, 0),
}));

const Footer = () => {
  const theme = useTheme();
  
  const primaryLinks = [
    { text: 'About', href: '/about' },
    { text: 'Contact us', href: '/contact-us' },
    { text: 'My Family Tree', href: '/my-family-tree' },
    { text: 'Find Relation', href: '/find-relation' },
    { text: 'Find Partner', href: '/find-partner' },
    { text: 'Gallery', href: '/gallery' },
  ];

  const secondaryLinks = [
    { text: 'Terms', href: '/terms-of-service' },
    { text: 'Privacy', href: '/privacy-policy' },
    { text: 'Settings', href: '/settings' },
  ];

  return (
    <StyledFooter>
      <div>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {/* Primary Links */}
          {/* <FooterLinksContainer>
            {primaryLinks.map((link, index) => (
              <React.Fragment key={index}>
                <Link href={link.href}>{link.text}</Link>
                {index < primaryLinks.length - 1 && (
                  <Typography 
                    variant="body2" 
                    color="text.secondary" 
                    sx={{ userSelect: 'none' }}
                  >
                    •
                  </Typography>
                )}
              </React.Fragment>
            ))}
          </FooterLinksContainer> */}

          {/* Secondary Links */}
          {/* <FooterLinksContainer>
            {secondaryLinks.map((link, index) => (
              <React.Fragment key={index}>
                <Link href={link.href}>{link.text}</Link>
                {index < secondaryLinks.length - 1 && (
                  <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{ userSelect: 'none' }}
                  >
                    •
                  </Typography>
                )}
              </React.Fragment>
            ))}
          </FooterLinksContainer> */}

          {/* Copyright */}
          <Typography 
            variant="caption" 
            color="text.secondary"
            sx={{ 
              mt: 1,
              fontSize: '0.8125rem',
            }}
          >
          Developed by SellSpark. All rights reserved.
          </Typography>
        </Box>
      </div>
    </StyledFooter>
  );
};

export default Footer; 